(() => {
  if (customElements.get('lv-second-set')) return;
  class LVSecondSet extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.busy = false;
      this.panel = this.querySelector('[data-lv-panel="0"]');
      this.button = this.querySelector('[data-lv-add]');
      this.status = this.querySelector('[role="status"]');
      this.addEventListener('change', event => {
        if (event.target.matches('[data-lv-option]')) this.update();
      });
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-lv-tab]');
        if (tab && !this.busy) {
          this.querySelectorAll('[data-lv-tab]').forEach(el => el.setAttribute('aria-pressed', String(el === tab)));
          this.querySelectorAll('[data-lv-panel]').forEach(el => { el.hidden = el.dataset.lvPanel !== tab.dataset.lvTab; });
          this.panel = this.querySelector(`[data-lv-panel="${tab.dataset.lvTab}"]`);
          this.status.textContent = '';
          this.update();
        }
        if (event.target.closest('[data-lv-add]')) this.add();
      });
      this.update();
    }
    selected() {
      const data = this.panel.querySelector('[data-lv-variants]');
      if (!data) return null;
      const values = [...this.panel.querySelectorAll('[data-lv-option]')].map(el => el.value);
      if (!values.length || values.some(value => !value)) return null;
      try { return JSON.parse(data.textContent).find(v => v.options.every((value, index) => value === values[index])); } catch { return null; }
    }
    price(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency || 'USD'}).format(cents / 100);
    }
    update() {
      const v = this.selected();
      this.button.disabled = this.busy || !v || !v.available;
      this.button.textContent = this.busy ? 'Adding…' : !v ? 'Choose a size to add' : !v.available ? 'Unavailable' : `Add this set · ${this.price(v.price)}`;
      if (v) this.panel.querySelector('[data-lv-price]').textContent = this.price(v.price);
    }
    async add() {
      const v = this.selected();
      if (this.busy || !v?.available) return;
      this.busy = true;
      this.status.textContent = '';
      this.setAttribute('aria-busy', 'true');
      this.querySelectorAll('select,[data-lv-tab]').forEach(el => { el.disabled = true; });
      this.update();
      try {
        const root = (window.Shopify?.routes?.root || this.dataset.root || '/').replace(/\/?$/, '/');
        let sections = ['cart-drawer','cart-count'];
        document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections',{bubbles:true,detail:{sections}}));
        sections = [...new Set(sections)].slice(0,5);
        const response = await fetch(`${root}cart/add.js`, {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:v.id,quantity:1}],sections,sections_url:location.pathname})
        });
        const result = await response.json();
        if (!response.ok) { const rejection = new Error(typeof result.description === 'string' ? result.description : 'This set could not be added. Please check your selection and try again.'); rejection.confirmedRejection = true; throw rejection; }
        this.status.textContent = 'Added. Opening your bag… ';
        const bag = document.createElement('a'); bag.href = this.dataset.cartUrl || `${root}cart`; bag.textContent = 'View bag'; bag.style.textDecoration = 'underline'; this.status.append(bag);
        const currentResponse = await fetch(`${root}cart.js`);
        if(!currentResponse.ok) throw new Error('Unable to refresh bag');
        const current = await currentResponse.json();
        current.sections = result.sections;
        if (!current.sections?.['cart-drawer'] || !current.sections?.['cart-count']) {
          const refresh = await fetch(root+'?'+sections.map(s=>'sections[]='+encodeURIComponent(s)).join('&'));
          current.sections = await refresh.json();
        }
        if (!current.sections?.['cart-drawer'] || !current.sections?.['cart-count']) throw new Error('Unable to refresh bag');
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate,{cart:current,productVariantId:String(v.id)});
        const drawer = document.querySelector('m-cart-drawer');
        if (!drawer || typeof drawer.open !== 'function') throw new Error('Unable to open bag');
        drawer.open(this.button);
        this.busy = false;
        this.removeAttribute('aria-busy');
        this.querySelectorAll('select,[data-lv-tab]').forEach(el=>{el.disabled=false});
        this.update();
      } catch (error) {
        if (!error.confirmedRejection) {
          this.status.textContent = 'We could not confirm the result. Please check your bag before trying again. ';
          const link = document.createElement('a'); link.href = this.dataset.cartUrl || '/cart'; link.textContent = 'View bag'; link.style.textDecoration = 'underline'; this.status.append(link);
          this.button.textContent = 'Check your bag'; this.removeAttribute('aria-busy'); return;
        }
        this.status.textContent = error.message;
        this.busy = false;
        this.removeAttribute('aria-busy');
        this.querySelectorAll('select,[data-lv-tab]').forEach(el => { el.disabled = false; });
        this.update();
      }
    }
  }
  customElements.define('lv-second-set', LVSecondSet);
})();
